import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { QuestionAssignmentState } from './types';

const initialState: Partial<QuestionAssignmentState> = {};

export const questionAssignmentSlice = createSlice({
  name: 'questionAssignment',
  initialState,
  reducers: {
    clearQuestionAssignment: () => initialState,
    setActiveAnswerId: (state, { payload }: PayloadAction<string | undefined>) => {
      state.activeAnswerId = payload;
    },
    setQuestionAssignment: (
      state,
      {
        payload,
      }: PayloadAction<Pick<QuestionAssignmentState, 'assignmentId' | 'questionAssignmentKey' | 'title' | 'questionId'>>
    ) => {
      state.assignmentId = payload.assignmentId;
      state.questionAssignmentKey = payload.questionAssignmentKey;
      state.title = payload.title;
      state.questionId = payload.questionId;
    },
  },
});

export const { clearQuestionAssignment, setActiveAnswerId, setQuestionAssignment } = questionAssignmentSlice.actions;
